export default {
  // Model state

  setCurrentUserId (state, id) {
    state.currentUserId = id
  },

  /**
  * userData: { firstName, lastName, language }
  */
  setUserData (state, userData) {
    state.userData = userData
  },

  /**
  * Clears all data associated with a user
  */
  clearUser (state) {
    state.currentUserId = null
    state.userData = null
    state.blackboard = null
  },

  setBlackBoard (state, blackboard) {
    state.blackboard = blackboard
  },

  // UI state

  setErrorMessage (state, errorMsg) {
    state.ui.errorMsg = errorMsg
  },

  setUILanguage (state, language) {
    state.ui.language = language
  },

  setIsAppEmbedded (state, value) {
    state.ui.isAppEmbedded = value
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js